<template lang="pug">
  div
    header#globalheader
      logo
      .fr
        pagetitle
        share
    #main
      mainarea(v-on:close="close")

    footer#globalfooter
      footerlogo
      timestamp
</template>

<script>
import Vue from 'vue';
import {mapGetters, mapActions, mapState} from 'vuex';

import $ from 'jquery'

/** Compponent in Root */
import Logo from './components/logo.vue';
import PageTitle from './components/pagetitle.vue';
import Share from './components/share.vue';
import FooterLogo from './components/footerlogo.vue';
import Timestamp from './components/timestamp.vue';
import MainArea from './components/mainarea.vue';

let logo = Vue.extend(Logo);
let pagetitle = Vue.extend(PageTitle);
let share = Vue.extend(Share);
let footerlogo = Vue.extend(FooterLogo);
let timestamp = Vue.extend(Timestamp);
let mainarea = Vue.extend(MainArea);

export default {
  name: 'app',
  components: {
    'logo': logo,
    'pagetitle': pagetitle,
    'share': share,
    'footerlogo': footerlogo,
    'timestamp': timestamp,
    'mainarea': mainarea
  },
  created: function(){
    const $w = $(window);
    $w.on('resize', () => {
      this.size.window.width = $w.width();
      this.size.window.height = $w.height();
      this.size.svg.width = this.size.window.width;
      this.size.svg.height = this.size.window.height - 180;
      this.size.timestamp = new Date().getTime();

    });
  },
  mounted: function(){
    this.init_data();
    document.title = this.get_title + ' | MEDITECH FINDER';

  },
  computed: {
    ...mapState([
      'previous_mode',
      'size',
    ]),
    ...mapGetters([
      'get_title',
    ]),
  },
  methods: {
    ...mapActions([
      'changeMode',
      'load_jsons',
    ]),
    close: function(){
      //console.log('close 1');
      this.changeMode(this.previous_mode);
    },
    init_data: function(){
      //console.log( 'init_data');
      this.load_jsons();
    }
  }

}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Signika');

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
